import { Radios, TabSwitcher } from './selectionController';
import Folders from './Folders/folder';
import DraggableFolder from './Folders/DraggableFolder';
import Templates from './templateDetailComponent/templates';
import ActionButtonGroup from './ActionButtonGroup';
import EditFolder from './editFolderComponent';
import TemplateDetail from './templateDetailComponent';
import Department from './department';
import User from './user';

export {
  Radios,
  TabSwitcher,
  DraggableFolder,
  Folders,
  Templates,
  ActionButtonGroup,
  EditFolder,
  TemplateDetail,
  Department,
  User,
};



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/index.js